<template>
  <div class="card-edit card-theme card-edit-new-theme project-view" :key="refreshDetail" v-on="dirtyListeners">
    <card-edit-subheader
      v-if="cardLoaded"
      :module="card.__t"
      :type="type"
      :card="card"
    >
    </card-edit-subheader>
    <div class="edit-body">
      <div
        class="has-background-grey-lighter card-basic column"
        v-if="cardLoaded"
      >
        <div class="is-flex hero-header is-size-3 columns is-marginless mb-3">
          <div
            class="column is-4 is-flex is-align-items-flex-end is-align-items-center"
          >
            <i class="has-text-white image is-32x32" :class="getDynamicClasses">
            </i>
            <h3 class="is-italic has-text-weight-bold">Template Name:</h3>
            <input
              class="input has-text-weight-bold generic-input"
              v-model="card.templateName"
            />
          </div>
          <div
            class="column is-4 is-flex is-align-items-flex-end is-align-items-center"
          >
            <h3 class="is-italic has-text-weight-bold">Template ID:</h3>
            <input
              class="input has-text-weight-bold generic-input"
              v-model="card.templateId"
            />
          </div>
          <div
            class="column is-4 is-flex is-offset-1 is-align-items-flex-end is-align-items-center"
          >
            <h3 class="is-italic ml-3 has-text-weight-bold">Type:</h3>
            {{
              card.purpose === "cutOrder"
                ? "Cut Order"
                : "Basic Production Order"
            }}
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="columns">
              <div class="column">
                <div class="field">
                  <h3
                    class="has-text-black-bis is-italic is-size-3 has-text-weight-bold line-height"
                  >
                    Name
                  </h3>
                  <div class="control is-flex-grow-1">
                    <input
                      class="input generic-input"
                      v-model.trim="card.name"
                    />
                  </div>
                </div>
                <div class="field">
                  <h3
                    class="has-text-black-bis is-italic is-size-3 has-text-weight-bold line-height"
                  >
                    ID
                  </h3>
                  <div class="control is-flex-grow-1">
                    <input
                      class="input generic-input"
                      v-model.trim="card.financialId"
                    />
                  </div>
                </div>
                <div class="field" v-if="card.purpose !== 'cutOrder'">
                  <h3
                    class="has-text-black-bis is-italic is-size-3 has-text-weight-bold line-height"
                  >
                    Est Hrs.
                  </h3>
                  <div class="column clock-width pl-0" >
                    <field-clock-display
                      v-bind="{ rowField: clockObj, rowData: card }"
                    />
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <h3
                    class="has-text-black-bis is-italic is-size-3 has-text-weight-bold line-height"
                  >
                    Activity
                  </h3>
                  <div class="control is-flex-grow-1">
                    <input
                      class="input generic-input"
                      v-model.trim="card.activity"
                    />
                  </div>
                </div>
                <field-user-select
                  titleLabel="Owner"
                  :isEditing="true"
                  :key="allCompanyUsers.length"
                  :options="allCompanyUsers"
                  :value="card.owner.user"
                  @update:value="(val) => $_.set(card, 'owner.user', val)"
                ></field-user-select>
              </div>
              <div class="column">
                <field-location-select
                  titleLabel="Location"
                  :isEditing="true"
                  :value="card.manager.location"
                  :options="allLocations"
                  @update:value="(val) => (card.manager.location = val)"
                ></field-location-select>
                <div class="field string-select">
                  <mf-multi-select
                    v-if="card.purpose !== 'cutOrder'"
                    v-model="card.stageUsed"
                    :options="stages"
                    :multiple="false"
                    @input="setStageUsed"
                    titleLabel="Stage Used"
                    labelClass="has-text-black-bis is-italic is-size-3"
                  ></mf-multi-select>
                  <div v-else>
                    <h3
                      class="has-text-black-bis is-italic is-size-3 has-text-weight-bold line-height"
                    >
                      Stage Used
                    </h3>
                    <p class="has-text-black-bis is-italic is-size-3 line-height">{{ $_.capitalize(card.stageUsed) }}</p>
                  </div>
                </div>
              </div>

              <div class="column pt-0 is-3-fullhd is-4-desktop">
                <h4 class="title is-capitalized">dates</h4>
                <div class="column">
                  <div class="columns" v-if="card.purpose !== 'cutOrder'">
                    <div class="column">
                      <h3
                        class="has-text-black-bis is-italic is-size-3 has-text-weight-bold"
                      >
                        Coordinate
                      </h3>
                    </div>
                    <div class="column">
                      <input
                        class="input generic-input"
                        v-model.number="card.leadDates.coordination"
                        type="number"
                        min="0"
                        max="730"
                        @keypress="rejectDot($event)"
                      />
                    </div>
                    <div class="column is-5">
                      <span>Days before Detail</span>
                    </div>
                  </div>

                  <div class="columns">
                    <div class="column">
                      <h3
                        class="has-text-black-bis is-italic is-size-3 has-text-weight-bold"
                      >
                        Detail
                      </h3>
                    </div>
                    <div class="column">
                      <input
                        class="input generic-input"
                        v-model.number="card.leadDates.detailing"
                        type="number"
                        min="0"
                        max="730"
                        :disabled="card.purpose !== 'cutOrder' ? disableLeadDate(card.leadDates.coordination) : false"
                        @keypress="rejectDot($event)"
                      />
                    </div>
                    <div class="column is-5" v-if="card.purpose !== 'cutOrder'">
                      <span>Days before Manuf</span>
                    </div>
                  </div>

                  <div class="columns" v-if="card.purpose !== 'cutOrder'">
                    <div class="column">
                      <h3
                        class="has-text-black-bis is-italic is-size-3 has-text-weight-bold"
                      >
                        Manuf
                      </h3>
                    </div>
                    <div class="column">
                      <input
                        class="input generic-input"
                        v-model.number="card.leadDates.manufacturing"
                        type="number"
                        min="0"
                        max="730"
                        :disabled="
                          disableLeadDate(card.leadDates.detailing) &&
                          card.purpose !== 'cutOrder'
                        "
                        @keypress="rejectDot($event)"
                      />
                    </div>
                    <div class="column is-5">
                      <span>Days before QA</span>
                    </div>
                  </div>

                  <div class="columns" v-if="card.purpose !== 'cutOrder'">
                    <div class="column">
                      <h3
                        class="has-text-black-bis is-italic is-size-3 has-text-weight-bold"
                      >
                        QA
                      </h3>
                    </div>
                    <div class="column">
                      <input
                        class="input generic-input"
                        v-model.number="card.leadDates.qa"
                        type="number"
                        min="0"
                        max="730"
                        :disabled="
                          disableLeadDate(card.leadDates.manufacturing) &&
                          card.purpose !== 'cutOrder'
                        "
                        @keypress="rejectDot($event)"
                      />
                    </div>
                    <div class="column is-5">
                      <span>Days before Onsite</span>
                    </div>
                  </div>

                  <div>
                    To use lead times, fill in all values. Otherwise, leave all
                    values blank.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="columns"
          :class="
            !accordionStatus
              ? 'hide-column'
              : 'pm-edit-show-column pm-edit-scroll'
          "
        >
          <div class="column">
            <div
              v-if="cardLoaded && card.customFields && card.customFields.length"
            >
              <h4
                class="is-italic is-size-3 is-italic has-text-weight-semibold mb-4"
              >
                Company Custom Fields
              </h4>
              <div class="column">
                <div class="columns has-seperator mb-5 pb-5 is-multiline">
                  <div
                    v-for="customField in card.customFields"
                    :key="customField._id"
                    class="column is-3"
                  >
                    <div class="">
                      <label
                        class="label is-size-3 has-text-black-bis is-italic"
                        v-tooltip="
                          customField.label.toLowerCase().toString().length > 24
                            ? customField.label
                            : ''
                        "
                      >
                        {{ customField.label }}
                      </label>
                    </div>

                    <!-- Checkbox Custom Field -->
                    <div
                      class="is-pulled-left"
                      v-if="customField.__t === 'Checkbox'"
                    >
                      <o-checkbox
                        v-model="customField.value"
                        v-tooltip="customField.label"
                      >
                      </o-checkbox>
                    </div>
                    <!-- Date Custom Field -->
                    <div
                      class="cf-modal-body is-pulled-left"
                      v-else-if="customField.__t === 'Date'"
                    >
                      <mf-date
                        :item="customField"
                        :is-edit="true"
                        :input-props="{ pos: 'bottom-right' }"
                        :placeholder="'mm/dd/yyyy'"
                        :isCustomFields="true"
                        @set-date="
                          ($event) => {
                            customField.value = $event.val;
                          }
                        "
                      />
                    </div>
                    <!-- Dropdown Custom Field -->
                    <div v-else-if="customField.__t === 'Dropdown'">
                      <mf-multi-select
                        v-model="customField.value"
                        :options="customField.options"
                        track-by="_id"
                        label="displayValue"
                        :multiple="false"
                        :allow-empty="false"
                        :closeOnSelect="true"
                        :placeholder="customField.placeholder"
                      />
                    </div>
                    <!-- Number Custom Field -->
                    <div v-else-if="customField.__t === 'Number'">
                      <qty-input
                        type="number"
                        min="0"
                        :max="99999.9999"
                        v-model.number="customField.value"
                        :roundTo="4"
                        :value="customField.value"
                        @update:value="
                          (val) => {
                            customField.value = val;
                          }
                        "
                        @blur="validateFields(customField)"
                        :class="customField.hasError ? 'archived-border' : ''"
                      ></qty-input>
                    </div>
                    <!-- String Custom Field -->
                    <div v-else-if="customField.__t === 'String'">
                      <input
                        class="input"
                        type="text"
                        v-model.trim="customField.value"
                        :placeholder="customField?.placeholder"
                        :class="customField.hasError ? 'archived-border' : ''"
                        @blur="validateFields(cf)"
                      />
                    </div>
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column" v-for="col of subDetails" :key="col.label">
                <base-column :fields="col.fields" :card="card"></base-column>
              </div>
            </div>
          </div>
        </div>
        <div
          class="column card-collapse is-clickable"
          @click="() => (accordionStatus = !accordionStatus)"
        >
          <div class="is-size-5 has-text-weight-normal is-capitalized">
            <i
              class="icon-disclosearrow"
              :class="!accordionStatus ? '' : 'rotate-180'"
            ></i>
            <span class="is-italic" v-if="!accordionStatus">show details</span>
            <span class="is-italic" v-else>hide details</span>
          </div>
        </div>
      </div>
      <div
        class="card-edit-item-table has-background-grey-lighter" id="temp-last-child"
        v-if="!accordionStatus"
      >
        <mf-detail-row
          v-if="cardLoaded"
          :rowData="card"
          :refreshCard="loadCard"
          @tabName="setTabName"
          @itemQtyUpdate="setItemQtyChanged"
          :tabLabel="selectedTabName"
          :cfColumns="cfColumns"
        >
        </mf-detail-row>
      </div>
    </div>
    <footer
      v-if="isDirty && hasPermission"
      class="card-footer"
      :class="buttonPosition === 'right' ? 'button-align-right' : ''"
    >
      <div class="buttons">
        <button class="button is-outlined is-danger" @click="loadCard">
          discard changes
        </button>
        <button class="button is-success" @click="save" :disabled="disableSave">
          save changes
        </button>
      </div>
    </footer>
  </div>
  <transition name="slide">
    <item-document-slider
      v-if="isFileListVisible"
      :isActive="isFileListVisible"
      :rowData="selectedItem"
      :rowField="rowField"
      @close="closeDocumentSlider"
      :card="card"
      :checkListOrder="checkListOrder"
    >
    </item-document-slider>
  </transition>
  <transition name="slide">
    <notes-icon-slider
      v-if="isSlideNotesActive"
      :isActive="isSlideNotesActive"
      :rowData="selectedItem"
      @close="closeNotesSlider"
      :isDisabled="isNotesDisabled"
      :isItem="isItem"
    >
    </notes-icon-slider>
  </transition>
  <o-loading :active="isLoading" fu></o-loading>
</template>

<script>
import {
  reactive,
  toRefs,
  onBeforeMount,
  onBeforeUnmount,
  inject,
  computed,
} from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import CardEditSubHeader from "@/components/card-edit/CardEditSubheader.vue";
import NotesIconSlider from "@/components/modals/NotesIconSlider.vue";
import ItemDocumentSlider from "@/components/modals/ItemDocumentSlider.vue";
import MfDetailRow from "@/components/table-fields/MfDetailRow.vue";
import CardFooter from "@/components/card-edit/CardFooter.vue";
import CardEditMixin from "@/components/mixins/CardEditMixin";
import { filter, set } from "lodash";
import ExcelInvalidData from "@/components/modals/ExcelInvalidData.vue";
import ProductionTemplates from "@/models/ProductionTemplates";
import Users from "@/models/Users";
import Locations from "@/models/Locations";
import QtyInput from "@/components/fields/QtyInput.vue";
import Validations from "@/utils/Validations";
import MfDate from "@/components/abstract/MfDate.vue";
import CustomFieldsOrderView from "@/components/card-edit/CustomFieldsOrderView.vue";
import BaseCardColumn from "@/components/card-edit/BaseCardColumn.vue";
import { useToast } from "vue-toastification";
import CustomFields from '@/models/CustomFields';
import { customFieldColsConfig } from '@/components/mixins/UtilityMixin';
import PermissionMixin from '@/components/mixins/PermissionMixin';

export default {
  name: "production-template-edit",
  components: {
    "card-edit-subheader": CardEditSubHeader,
    "mf-detail-row": MfDetailRow,
    "card-footer": CardFooter,
    "notes-icon-slider": NotesIconSlider,
    "item-document-slider": ItemDocumentSlider,
    ExcelInvalidData,
    QtyInput,
    MfDate,
    "base-column": BaseCardColumn,
    CustomFieldsOrderView,
  },
  props: {
    projectId: {
      type: String,
      required: true,
    },
    cardId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { onInitDirty, templateCardValidations, saveCard } = CardEditMixin();
    const emitter = inject("emitter");
    const router = useRouter();
    const store = useStore();
    const toast = useToast();
    const { getPermissionValues } = PermissionMixin();
    // data
    const data = reactive({
      card: {},
      cardLoaded: false,
      isLoading: false,
      type: "",
      allCompanyUsers: [],
      allLocations: [],
      accordionStatus: false,
      selectedTabName: "",
      itemQtyChanged: false,
      selectedItem: {},
      rowField: {},
      isFileListVisible: false,
      checkListOrder: {},
      isSlideNotesActive: false,
      isNotesDisabled: false,
      isItem: false,
      refreshDetail: 0,
      cfColumns: [],
      hasPermission: true
    });

    const clockObj = {
      inputProps: {
        type: "number",
        min: "0",
        max: "999",
        step: "1",
        isLeft: true,
        fromWorkStep: true,
        showNum: true,
        fieldDirtyRequired: true,
      },
      prop: "estHrs",
    };

    const subDetails = [
      {
        label: "col1",
        fields: [
          {
            name: "field-file-list",
            prop: "simpleFiles",
            label: "files",
          },
        ],
      },
      {
        label: "col2",
        fields: [
          {
            name: "field-notes",
            prop: "currentNote",
            label: "Notes",
          },
        ],
      },
      {
        label: "col3",
        fields: [
          {
            name: "field-tags",
            prop: "tags",
            label: "Tags",
          },
        ],
      },
    ];
    onInitDirty(data);

    const loadCard = async () => {
      try {
        data.isLoading = true;
        await store.getters.userPromise;
        data.type = store.state.activeScreen;
        onInitDirty(data);
        data.card = await ProductionTemplates.getTemplates({
          cardId: props.cardId,
          projectId: props.projectId,
        });
        data.cardLoaded = true;
        data.card.items.forEach((item) => {
          set(item, "isEditing", true);
          if (!item.simpleMemos || item.simpleMemos.length === 0) {
            item.newFTD("memos");
          }
        });
        data.card.manager.runs.forEach((t) => {
          t.isEditing = true;
        });
        data.card.manager.runItemsIndexMap();
        await getAllCompanyUsers();
        const locs = await Locations.allLocationForUser({
          companyIds: data.card.getInvolvedCompanies(),
          projectId: data.card.project._id,
        });
        data.allLocations = Locations.groupLocations(
          locs,
          store.state.companyData
        );
        if (data.card.customFields && data.card.customFields.length > 0) {
          data.card.customFields.forEach((cf) => {
            if (cf.__t === "Date" && cf.value) cf.value = new Date(cf.value);
          });
        }
      } catch (e) {
        console.error("Error: ", e);
      } finally {
        data.isLoading = false;
        data.refreshDetail += 1;
      }
    };

    onBeforeMount(async () => {
      data.hasPermission = !(getPermissionValues({
        permissionModule: 'app&projects',
        type: 'company_templates',
      }))
      await loadCard();
      if (data.card.purpose === 'general') {
        const itemsCustomFields = await CustomFields.getCustomFields({ type: 'po_item'});
        if (!_.isEmpty(itemsCustomFields)) {
        itemsCustomFields.fields.forEach((cf) => {
          const cfColConfig = customFieldColsConfig[cf.__t];
          if (cfColConfig && (cf.__t !== 'String' || (cf.__t === 'String' && cf.uniqueAcross === 'none'))) {
            data.cfColumns.push({
              name: cfColConfig.name,
              width: cfColConfig.width,
              title: cf.label,
              customField: cf,
              isEditable: true,
              customHeader: true,
            });
          }
        });
      }
      }
      data.cardLoaded = true;
      data.itemsLoaded = true;
    });

    const getDynamicClasses = computed(() => {
      const routeMeta = router.currentRoute.value.meta;
      let classes = "";
      if (routeMeta.activeViewColor) {
        classes = `${routeMeta.activeViewColor} `;
      }
      if (routeMeta.cardEditIcon) {
        classes += `icon-${routeMeta.cardEditIcon}`;
      }
      return classes;
    });

    const stages = computed(() => {
      if (data.card.purpose === "cutOrder")
        return ["Detailing", "Manufacturing"];
      return ["All", "Coordination", "Detailing", "Manufacturing"];
    });

    const setStageUsed = (val) => {
      set(data.card, "stageUsed", val.toLowerCase());
    };

    const getAllCompanyUsers = async () => {
      const user = store.state.userData;
      let allUsers;
      const orderCreator = {
        _id: "(Order Creator)",
        name: "(Order Creator)",
        companyName: user.companyName,
      };
      if (["MatTemplates", "ProdTemplates"].includes(data.card.__t)) {
        allUsers = (await Users.allUsers({ limit: 1000 })).data;
        allUsers = filter(allUsers, (user) => user.activated && !user.archived);
        allUsers.unshift(orderCreator);
      }

      data.allCompanyUsers = Users.groupUsers(allUsers);
    };

    const rejectDot = (event) => {
      if (event.keyCode === 46) event.preventDefault();
    };

    const disableLeadDate = (date) => {
      return typeof date !== "number";
    };

    const validateFields = async (cf) => {
      const isValid = await Validations.validateCustomFields(
        cf,
        data.card,
        store.state.userData,
        false,
        "prod-custom-fields"
      );
      return isValid;
    };

    const setTabName = (val) => {
      data.selectedTabName = val;
    };

    const setItemQtyChanged = (val) => {
      data.itemQtyChanged = val;
    };

    const closeDocumentSlider = () => {
      data.isFileListVisible = false;
    };

    emitter.on("toggle:itemDocsSlider", (payload) => {
      data.isSlideNotesActive = !payload.isActive;
      data.selectedItem = payload.data;
      data.rowField = payload.rowField;
      data.isFileListVisible = payload.isActive;
      data.checkListOrder = payload.checkListOrder || data.checkListOrder;
    });

    emitter.on("toggle:notesSlider", (payload) => {
      // *Listen* for event
      data.isFileListVisible = !payload.isActive;
      data.selectedItem = payload.data;
      data.isItem = payload.isItem;
      data.isSlideNotesActive = payload.isActive;
      data.isNotesDisabled = payload.isDisabled;
    });

    onBeforeUnmount(() => {
      emitter.off("toggle:itemDocsSlider");
      emitter.off("toggle:notesSlider");
    });

    const closeNotesSlider = () => {
      data.isSlideNotesActive = false;
      data.selectedItem = {};
    };

    const save = async () => {
      try {
        data.isLoading = true;
        const validationResult = templateCardValidations(data.card);
        if (validationResult) {
          toast.error(validationResult);
          return false;
        }
        if (data.card.__t === "ProdTemplates") {
          if (data.card.isDefault) data.card.stageUsed = "all";
          else data.card.stageUsed = data.card.stageUsed.toLowerCase();
        }
        await saveCard(data.card._id, "", data.card);
        await loadCard();
      } catch (e) {
        console.error("Error: ", e);
        const errMsg = e?.data?.msg || e.message;
        if (errMsg) toast.error(errMsg);
      } finally {
        data.isLoading = false;
      }
    };

    return {
      ...toRefs(data),
      getDynamicClasses,
      stages,
      setStageUsed,
      clockObj,
      rejectDot,
      disableLeadDate,
      validateFields,
      subDetails,
      loadCard,
      setTabName,
      setItemQtyChanged,
      closeDocumentSlider,
      closeNotesSlider,
      save,
    };
  },
};
</script>

<style scoped>
::v-deep(.string-select .multiselect__single) {
  text-transform: capitalize;
}
.clock-width {
  width: 150px;
}
</style>
